import React from 'react';
import PropTypes from 'prop-types';
import HotspotRotator from '../../HotspotRotator';
import { Row, Col } from 'react-flexa';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Emphasis from '../../components/Emphasis';
import Typography from '../../components/Typography';
import hotspots from '../data/hotspots.json';

const styles = theme => ({
  root: {
    background: 'linear-gradient(180deg,#fff,#efefef)', 
    padding: '2rem 0',
  },
  emphasis: {
    color: theme.palette.primary.main,
    lineHeight: 1,
    letterSpacing: -1.32,
    fontFamily: "BornReady-Slanted"
  },
});

class HotspotRotatorSection extends React.Component {
  state = {
    buttonHover: false,
  };

  toggleButtonHover = (buttonHover) => e => {
    this.setState({buttonHover});
  };

  render() {
    const { classes, otherClasses } = this.props;
    const { buttonHover } = this.state;
    return (
      <div className={classes.root}>
        <div style={{maxWidth: 1200, margin: '4rem auto'}}>
          <Row gutter={0} justifyContent='center'>
            <Col xs={12} sm={12} md={4} style={{padding: '1rem'}}>
              <Typography variant='subtitle2'>GUARANTEED SAVINGS WITH EVERY PURCHASE</Typography>
              <Typography variant='h2'>
                Find Your Favorite Products for the
                <Emphasis style={{display: 'block'}}> Right Price.</Emphasis>
              </Typography>
              <Typography variant='body2' style={{marginTop: 8}}>
                DirectBuy members save $3,800 on average in their first year of membership. Simply put, your
                membership practically pays for itself. Start saving today on everything from home appliances,
                furniture, kitchen and bathroom essentials, cabinets, flooring and more!
              </Typography>
              <Button
                component='a'
                href='/v2/membership-pricing/'
                color='primary'
                size='large'
                fullWidth={true}
                className={otherClasses.button}
                variant={buttonHover ? 'contained' : 'outlined'}
                onMouseOver={this.toggleButtonHover(true)}
                onMouseLeave={this.toggleButtonHover(false)}
              >
                Become a Member
              </Button>
            </Col>
            <Col xs={12} sm={12} md={8} style={{padding: '0 2%'}}>
              <HotspotRotator images={hotspots} />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

HotspotRotatorSection.propTypes = {
  classes: PropTypes.object.isRequired,
  otherClasses: PropTypes.object.isRequired,
};

export default withStyles(styles)(HotspotRotatorSection)
